<template>
  <div>
    <span @click.prevent="trigger(1)" class="absolute z-20 pin-t pin-r w-32 h-32 block overflow-hidden opacity-0">1</span>
    <span @click.prevent="trigger(2)" class="absolute z-20 pin-b pin-r w-32 h-32 block overflow-hidden opacity-0">2</span>
    <span @click.prevent="trigger(3)" class="absolute z-20 pin-t pin-l w-32 h-32 block overflow-hidden opacity-0">3</span>
    <span @click.prevent="set" class="absolute z-20 pin-b pin-l w-32 h-32 block overflow-hidden opacity-0">SET</span>
  </div>
</template>
<script>
export default {
  name: 'debug-landing-trigger',

  data () {
    return {
      order: '12311',
      animation: '333',
      input: ''
    }
  },

  methods: {
    trigger (btn) {
      this.input = this.input + btn
    },

    set () {
      if (this.input === this.order) {
        this.input = ''
        this.$router.push('/debug')
      }

      if (this.input === this.animation) {
        this.input = ''
        this.$router.push('/animation')
      }

      this.input = ''
    }
  }
}
</script>
